export enum Units {
    MetricWeight = 'kg',
    UkImperialWeight = 'st',
    ImperialWeight = 'lbs'
}
